// @flow
import React from "react";
import { connect } from "react-redux";
import cx from "classnames";
import { createStructuredSelector } from "reselect";
import { selectShowPoweredBy } from "../../selectors";
import PoweredBy from "../PoweredBy/PoweredBy";

import "./Footer.scss";

type Props = {
    showPoweredBy: boolean,
    footerClassName?: string,
    children: Object[],
};

export const Footer = ({ showPoweredBy, footerClassName = "", children }: Props) => {
	const cls = cx(
		"bg-window",
		"flex",
		"items-center",
		"foot",
		{
			// $FlowFixMe - flow doesnt allow to use computed props with dynamic values
			[footerClassName]: footerClassName,
			"justify-end": !showPoweredBy,
			"justify-between": showPoweredBy,
		},
	);

	return <footer
		className={cls}>
		{showPoweredBy && <PoweredBy data-test="powered-by"/>}
		{children}
	</footer>;
};

export default connect<Props, *, *, *, *, *>(
	createStructuredSelector({
		showPoweredBy: selectShowPoweredBy,
	}),
)(Footer);
